import { render } from "./NotesDisabled.vue?vue&type=template&id=11ebcba4&scoped=true"
import script from "./NotesDisabled.vue?vue&type=script&lang=js"
export * from "./NotesDisabled.vue?vue&type=script&lang=js"

import "./NotesDisabled.vue?vue&type=style&index=0&id=11ebcba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ebcba4"]])

export default __exports__